export const CardPointeTerminalTokenizationOutcome = {
    TOKEN_CREATED: 'token_created',
    CANCELED: 'canceled',
    UNSUPPORTED_TERMINAL: 'unsupported_terminal',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CardPointeTerminalTokenizationOutcome =
    (typeof CardPointeTerminalTokenizationOutcome)[keyof typeof CardPointeTerminalTokenizationOutcome];

export interface CardPointeTerminalTokenizationRequestBody {
    readonly merchantId: string;
    readonly hsn: string;
    readonly amount: string;
    readonly aid?: 'debit' | 'credit';
    readonly includeSignature?: boolean;
    readonly beep?: boolean;
}

export interface CardPointeTerminalTokenizationRequestDetails {
    readonly method: 'POST';
    readonly path: '/api/v4/readCard';
    readonly body: CardPointeTerminalTokenizationRequestBody;
}

export interface CardPointeTerminalTokenizationSuccessBody {
    readonly token: string;
    readonly expiry?: string;
    readonly name?: string;
    readonly singleUseToken?: boolean;
    readonly signature?: unknown;
}

export interface CardPointeTerminalTokenizationErrorBody {
    readonly errorCode: string;
    readonly errorMessage: string;
}

export type CardPointeTerminalTokenizationResponseDetails =
    | {
          readonly outcome: typeof CardPointeTerminalTokenizationOutcome.TOKEN_CREATED;
          readonly httpStatus: 200;
          readonly body: CardPointeTerminalTokenizationSuccessBody;
      }
    | {
          readonly outcome: typeof CardPointeTerminalTokenizationOutcome.CANCELED;
          readonly httpStatus: number;
          readonly body: CardPointeTerminalTokenizationErrorBody;
      }
    | {
          readonly outcome: typeof CardPointeTerminalTokenizationOutcome.UNSUPPORTED_TERMINAL;
          readonly httpStatus: number;
          readonly body: CardPointeTerminalTokenizationErrorBody;
      }
    | {
          readonly outcome: typeof CardPointeTerminalTokenizationOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly body: unknown;
          readonly message: string;
      };

export type CardPointeTerminalTokenizationResult =
    | {
          readonly status: typeof CardPointeTerminalTokenizationOutcome.TOKEN_CREATED;
          readonly gatewayToken: string;
          readonly expiry?: string;
          readonly cardholderName?: string;
          readonly singleUseToken?: boolean;
      }
    | {
          readonly status:
              | typeof CardPointeTerminalTokenizationOutcome.CANCELED
              | typeof CardPointeTerminalTokenizationOutcome.UNSUPPORTED_TERMINAL
              | typeof CardPointeTerminalTokenizationOutcome.MALFORMED_RESPONSE;
          readonly message: string;
      };
